import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[app-insights-library__item-selector__item-description]',
  standalone: false
})
export class InsightsLibraryItemSelectorItemDescriptionDirective {
  constructor(public readonly templateRef: TemplateRef<unknown>) {
  }
}
